import { CheckoutState } from '../state';
import { getNamespaceValue } from './utils/selector';

export const getExpirationTimestamp = (state: CheckoutState) =>
    getNamespaceValue(state.timer, 'expirationTimestamp');

export const getIsTimerExpired = (state: CheckoutState) =>
    getNamespaceValue(state.timer, 'isTimerExpired');
